import React from "react";
type TextProps = {
  color?: string;
};

const Text: React.FC<TextProps> = ({ color = "#000" }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="3.5" y="3.5" width="17" height="17" rx="0.5" stroke={color} />
      <path
        d="M10.8879 18.5V7.88H7.55787V6.026H16.4499V7.88H13.1199V18.5H10.8879Z"
        fill="#212121"
      />
    </svg>
  );
};

export default Text;
